























import ModalMixin from '@/mixins/modal.mixin';
import { Component, Mixins } from 'vue-property-decorator';

@Component
export default class UserModal extends Mixins(ModalMixin) {
  form = this.$crsForm('users', 'update', {
    password: '',
  });
}
